import * as z from 'zod';

export const reportTemplatePeriodFormSchema = z
  .object({
    start_datetime: z.date(),
    end_datetime: z.date(),
  })
  .refine((data) => data.end_datetime > data.start_datetime, {
    message: 'End date must be after start date',
    path: ['end_datetime'],
  });

export type reportTemplatePeriodValues = z.infer<
  typeof reportTemplatePeriodFormSchema
>;

export function createReportTemplatePeriodFormSchema(
  startThreshold?: Date | null,
  endThreshold?: Date | null,
  startThresholdText?: string | null,
  endThresholdText?: string | null,
  existingSchema?: any
) {
  let schema = existingSchema ? existingSchema : reportTemplatePeriodFormSchema;

  if (startThreshold) {
    schema = schema.refine(
      (data: any) => data.start_datetime >= startThreshold,
      {
        message: `Start date must be within the data range, which is above ${startThresholdText}`,
        path: ['start_datetime'],
      }
    ) as any;
  }

  // Add validation for endDatetimeThreshold if it exists
  if (endThreshold) {
    schema = schema.refine((data: any) => data.end_datetime <= endThreshold, {
      message: `End date must be within the data time range, which is below ${endThresholdText}`,
      path: ['end_datetime'],
    }) as any;
  }

  return schema;
}
